<template>
  <div class="columns is-gapless full-width">
    <div class="column is-narrow list-border is-hidden-touch">
      <LikeLog class="force-show-list" :is_show_edit_button="false"/>
    </div>
    <div class="column list-content">
      <div style="margin: 0.5em">
        <div>
          <div style="text-align: right;">
            <b-tooltip label="フォローしているアカウントの一覧に移動します"
                position="is-left" always :active="tooltipActive">
              <b-icon icon="heart" style="margin-left:1em;"
                      @click.native="$router.push('/likes_followed')">
              </b-icon>
            </b-tooltip>
          </div>
          <div class="list-header">
            {{account_info.name}}
            <p class="is-size-4 has-text-grey-dark">
              {{list_title}}のいいね
              <b-icon icon="info-circle" type="is-info" size="is-small" @click.native="isInfoActive = !isInfoActive"/>
            </p>
            <b-notification :active="isInfoActive" has-icon type="is-info"
                            aria-close-label="Close notification">
              下のバーをドラッグすることで、指定した範囲のリツイート数のツイートだけを表示することができます。
            </b-notification>
            <b-field class="search-padding">
              <b-slider :min="0" :max="5" aria-label="Fan" :tooltip="false" v-model="rtThrBar">
                <b-slider-tick :value="0">0RT</b-slider-tick>
                <b-slider-tick :value="1">10RT</b-slider-tick>
                <b-slider-tick :value="2">100RT</b-slider-tick>
                <b-slider-tick :value="3">1000RT</b-slider-tick>
                <b-slider-tick :value="4">10000RT</b-slider-tick>
                <b-slider-tick :value="5">...</b-slider-tick>
              </b-slider>
            </b-field>
            <b-pagination
                :total="list_tweets.length"
                :current.sync="current_page_num"
                :range-before="2"
                :range-after="1"
                :order="'is-centered'"
                :size="''"
                :rounded="true"
                :per-page="one_page_tweet_num"
                :icon-prev="'chevron-left'"
                :icon-next="'chevron-right'"
                aria-next-label="Next page"
                aria-previous-label="Previous page"
                aria-page-label="Page"
                aria-current-label="Current page"
                type="is-danger">
            </b-pagination>
          </div>
        </div>
        <div  class="columns is-gapless is-multiline is-desktop">
          <div v-for="tweet in tweet_contents" :key="tweet.id" class="column is-4-desktop">
            <TweetBox :tweet_info="tweet" @tweet-regist="changeRegistState(tweet.id)"/>
          </div>
        </div>
        <div style="padding: 0.5em;" class="list-header">
          <b-pagination
              :total="list_tweets.length"
              :current.sync="current_page_num"
              :range-before="2"
              :range-after="1"
              :order="'is-centered'"
              :size="''"
              :rounded="true"
              :per-page="one_page_tweet_num"
              :icon-prev="'chevron-left'"
              :icon-next="'chevron-right'"
              aria-next-label="Next page"
              aria-previous-label="Previous page"
              aria-page-label="Page"
              aria-current-label="Current page"
              type="is-danger">
          </b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TweetBox from '@/components/TweetBox.vue'
import LikeLog from '@/views/LikeLog.vue'
import {getFavTweetsFileFromGCS} from '@/util/favlog_util.js'

export default {
  title() {
    return "- " + this.account_info.name + "のいいね"
  },
  components: {
    TweetBox,
    LikeLog,
  },
  data() {
    return {
      all_tweet_info_list: [],
      list_tweets: [],
      tweet_contents: [],
      current_page_num: 1,
      rtThrBar: [0, 5],
      rtThrHigh: 100000000000,
      rtThrLow: 0,
      tooltipActive: true,
      isInfoActive: false,
    }
  },
  computed: {
    list_title() {
      return this.show_month.slice(0, 4) + "/" + this.show_month.slice(4)
    },
    one_page_tweet_num: () => 30,
    page_num() {
      if(this.$route.query.page == undefined){return 1}
      return this.$route.query.page
    },
    user_id() {
      return this.$route.query.id
    },
    show_month() {
      return this.$route.query.month
    },
    account_info() {
      return this.$store.getters['getLikeFollowUsers']
              .filter(info => info.id == this.user_id)[0]
    },
  },
  watch:{
    current_page_num(val) {
      this.move_list_page(val)
    },
    show_month: {
      handler: "getFavTweetList",
      immediate: true,      
    },
    rtThrBar(val) {
      this.rtThrLow = Math.pow(10, val[0])
      this.rtThrHigh = val[1] < 5 ? Math.pow(10, val[1]) : 100000000000
      this.filterTweets()
      this.move_list_page(1)
    }
  },
  created() {
    setTimeout(function() {
      this.tooltipActive = false
    }.bind(this), 5000)
  },
  methods: {
    async getFavTweetList() {
      const favObj = await getFavTweetsFileFromGCS(this.user_id, this.show_month)
      this.all_tweet_info_list = favObj.tweets
      this.filterTweets()
      await this.getTweetInfoList()
    },
    filterTweets() {
      this.list_tweets = this.all_tweet_info_list.filter((obj) => this.rtThrLow <= obj.rt && obj.rt <= this.rtThrHigh)
                                                 .map((obj) => obj.id)
    },
    move_list_page(move_page) {
      if(this.list_tweets.length <= this.one_page_tweet_num*(move_page-1)) return
      window.scrollTo({top: 80})
      const nextQuery = {page: move_page, id: this.user_id, month: this.show_month}
      this.$router.push({path:`/likes_followed_log_page`, query: nextQuery}).catch(()=>{})
      this.getTweetInfoList()
    },
    async getTweetInfoList() {
      const start_idx = this.one_page_tweet_num*(this.page_num-1)
      const end_idx = start_idx + this.one_page_tweet_num
      const tgt_list_tweets = this.list_tweets.filter((elm, idx) => start_idx<=idx && idx<end_idx)
      this.tweet_contents = []
      for(let idx in tgt_list_tweets){
        const tweetInfo = await this.$store.dispatch('getTweetInfoByID', tgt_list_tweets[idx])
        if(Object.keys(tweetInfo).length == 0) continue  // 空のオブジェクトは飛ばす
        tweetInfo.registeredListname = this.$store.getters.findRegistedList(tweetInfo.id)
        this.tweet_contents.push(tweetInfo)
      }
    },
    changeRegistState(tweet_id) {
      const idx = this.tweet_contents.findIndex((obj) => obj.id === tweet_id)
      if(idx >= 0){
        this.tweet_contents[idx].registeredListname = this.$store.getters.findRegistedList(tweet_id)
      }
    },
  },
}
</script>

<style>
.search-padding {
  margin-right: 0.5em;
  margin-left: 0.5em;
  padding-bottom: 0.25em;
}

.list-header {
  max-width: 40em;
  margin: 0 auto;
}

.force-show-list {
  margin-top:0px !important;
  width: 240px !important;
}

.list-border {
  border-right: 1px solid #cccccc;
}

.full-width {
  max-width: none !important;
}

.list-content {
  max-width: 1300px;
	margin-left: auto !important;
	margin-right: auto !important;
}
</style>